function isMobile() {
    return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
}

const NEED_CLEAN_APP_PREFIX = [
    "/mmf-web/hazard/",
    "/mmf-web/login"
];

function isNeedCleanApp(url) {
    if (isMobile()) {
        for (let item of NEED_CLEAN_APP_PREFIX) {
            if (url.startsWith(item)) {
                return true;
            }
        }
    }
    return false;
}

export {
    isMobile,
    isNeedCleanApp
}
